module.exports = __webpack_public_path__ + "static/media/metadata.eb832869.info";